import { persons } from "@/mocks/scandal";
import SectionHead from "./SectionHead";

export default function PersonArchive() {
  return (
    <section id="archive" className="scroll-mt-24 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHead
            eyebrow="人物起底 / PERSON FILES"
            title="起底档案 · 本期在盯的人"
            desc="一档一人，拆人设、核履历、回旧料。下面只展示公开信息整理与待核实状态，不代表定性结论。"
          />
          <span className="inline-flex items-center gap-2 whitespace-nowrap font-label text-xs text-foreground-500">
            <i className="ri-time-line text-primary-500" />
            档案每 24 小时更新一次
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {persons.map((p) => (
            <a
              key={p.name}
              href="#archive"
              className="group flex flex-col overflow-hidden rounded-lg border border-foreground-950/6 bg-background-50 transition-all hover:-translate-y-0.5 hover:border-foreground-950/20"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.name + " 人物起底档案"}
                  title={p.name + " 人物起底"}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent" />
                <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2 py-1 font-label text-[11px] text-background-50">
                  {p.label}
                </span>
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="flex items-end justify-between">
                    <h3 className="font-heading text-xl font-bold text-background-50">{p.name}</h3>
                    <span className="flex items-center gap-1 font-label text-[11px] text-background-200">
                      <i className="ri-fire-line" />
                      {p.heat}
                    </span>
                  </div>
                  <p className="mt-0.5 font-label text-[11px] text-background-200">{p.role}</p>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <p className="text-[13px] leading-6 text-foreground-700">{p.summary}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {p.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-accent-100 px-2.5 py-1 font-label text-[11px] text-accent-800"
                    >
                      #{t}
                    </span>
                  ))}
                </div>
                <span className="mt-auto flex items-center gap-1.5 pt-4 font-label text-xs text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                  进入该档案
                  <i className="ri-arrow-right-line text-xs" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}